import { render, staticRenderFns } from "./TestPackageCard.vue?vue&type=template&id=2d9c3120"
import script from "./TestPackageCard.vue?vue&type=script&lang=js"
export * from "./TestPackageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports